import { ProjectIntegrationType } from 'types'

export const isShotgridTaskSourceDetails = (
  sourceDetails: ShotgridTaskSourceDetails | JiraTaskSourceDetails,
): sourceDetails is ShotgridTaskSourceDetails => {
  return sourceDetails.type === ProjectIntegrationType.ShotGrid
}

export const isJiraTaskSourceDetails = (
  sourceDetails: ShotgridTaskSourceDetails | JiraTaskSourceDetails,
): sourceDetails is JiraTaskSourceDetails => {
  return sourceDetails.type === ProjectIntegrationType.Jira
}
